import { Component, Input, Output, EventEmitter, OnInit } from '@angular/core';
import { Platform, MenuController, Events } from 'ionic-angular';
import { BarcodeScanner } from '@ionic-native/barcode-scanner/ngx';
import { GoogleAnalytics } from '@ionic-native/google-analytics/ngx';

import { qrCodeService } from '../../app/shared/services/qrCode.service';
import { LastScansService } from '../../app/shared/services/lastScans.service';
import { AuthService } from '../../app/shared/services/auth.service';

@Component({
    selector: 'ec-menu',
    templateUrl: 'menu.html'
})
export class MainNavigationComponent implements OnInit {
    @Input() menuTitle: string = "SOCOTEC Avantage";
    @Input() hasSubMenu: boolean = true;
    @Input() isAuth: boolean = false;
    @Output() pageClicked: EventEmitter<any> = new EventEmitter();
    private hasLastScans: boolean = false;
    private isElementVerifie: boolean = false;
    private loader: boolean = false;
    private lastScans: Array<any> = [];
    private user: string = '';
    private qrCodeScan: string = '';

    constructor(
    private menu: MenuController,
     private events: Events,
     private platform: Platform,
     private barcodeScanner: BarcodeScanner,
     private ga: GoogleAnalytics,
     private qrCodeService: qrCodeService,
     private lastScansService: LastScansService,
     private authService: AuthService
    ) {
    }

    ngOnInit() {
        this.init();
    }

    async init(): Promise<any> {
        const liste = await this.lastScansService.getLastScans();
        const token = await this.authService.getToken();
        this.user = (token !== null) ? token.user : '';
        if(liste !== null) {
            for(let i in liste) {                                
                if(liste[i].user == this.user) {
                    this.lastScans = liste[i].scans[0].data;
                    this.hasLastScans = true;
                    this.isElementVerifie = (liste[i].scans[0].qrCodeType == "Equipement");
                }
            }
        }
        this.lastScansService.listeScans.subscribe(async (liste: Array<any>) => {
            const token = await this.authService.getToken();
            for (let i in liste) {
                if (liste[i].user == token.user) {
                    this.lastScans = liste[i].scans[0].data;
                    this.hasLastScans = true;
                    this.isElementVerifie = (liste[i].scans[0].qrCodeType == "Equipement");
                    break;
                } else {
                    this.lastScans = [];
                    this.hasLastScans = false;
                    this.isElementVerifie = false;
                }
            }
        });
        this.events.subscribe( 
            'scanSansRapport:qrCode', qrCode => {
                this.qrCodeScan = qrCode;
            }
        );
    }

    scan(): any {
        this.barcodeScanner.scan().then(async (barcodeData: any) => {
            if (!barcodeData.cancelled) {
                this.platform.ready().then(_ => {
                    this.ga.trackEvent("Scan QRCode", "scan");
                });
                this.loader = true;
                this.qrCodeService.getScanQRCode(barcodeData.text).subscribe( async (scan: any) => {
                    const token = await this.authService.getToken();
                    if (token !== null) {
                        const user = token.user;
                        if (scan.data.perimetre !== undefined) {
                            await this.lastScansService.setLastScans(user, scan);
                            this.platform.ready().then(_ => {
                                if (barcodeData.text.match("socotec")) {
                                    this.ga.trackEvent("QRCode valide SOCOTEC", "scan");
                                } else {
                                    this.ga.trackEvent("QRCode valide Non SOCOTEC", "scan");
                                }
                            });
                            if (scan.qrCodeType === "Installation") {
                                this.goToPage('rapport', null);
                            } else {
                                this.goToPage('element-verifie', null);
                            }
                        } else {
                            const refreshToken = await this.authService.getRefreshToken();
                            if (refreshToken !== null) {
                                this.authService.refresh(refreshToken).subscribe( async (res: any) => {
                                    const newToken = await this.authService.getToken();
                                    await this.authService.setToken(newToken.user, res.access_token, res.statut);
                                    await this.authService.setRefreshToken(res.refresh_token);
                                    this.qrCodeService.getScanQRCode(barcodeData.text).subscribe(async (scan: any) => {
                                        const user = newToken.user;
                                        await this.lastScansService.setLastScans(user, scan);
                                        this.platform.ready().then(_ => {
                                            if (barcodeData.text.match("socotec")) {
                                                this.ga.trackEvent("QRCode valide SOCOTEC", "scan");
                                            } else {
                                                this.ga.trackEvent("QRCode valide Non SOCOTEC", "scan");
                                            }
                                        });
                                        if (scan.qrCodeType === "Installation") {
                                            this.goToPage('rapport', null);
                                        } else {
                                            this.goToPage('element-verifie', null);
                                        }
                                    });
                                });
                            } else {
                                await this.authService.removeToken();
                                await this.authService.removeRefreshToken();
                                this.platform.ready().then(_ => {
                                    if (barcodeData.text.match("socotec")) {
                                        this.ga.trackEvent("QRCode valide SOCOTEC", "scan");
                                    } else {
                                        this.ga.trackEvent("QRCode valide Non SOCOTEC", "scan");
                                    }
                                });
                                this.goToPage('rapport-sans-acces', scan);
                            }
                        }
                    } else {
                        this.platform.ready().then(_ => {
                            if (barcodeData.text.match("socotec")) {
                                this.ga.trackEvent("QRCode valide SOCOTEC", "scan");
                            } else {
                                this.ga.trackEvent("QRCode valide Non SOCOTEC", "scan");
                            }
                        });
                        this.goToPage('rapport-sans-acces', scan);
                    }
                }),
                (error: any) => {
                    console.error(error);
                    this.menu.close();
                    this.loader = false;
                    this.platform.ready().then(_ => {
                        if (error.status === 403) {
                            this.ga.trackEvent("QRCode permission refusée", "scan");
                        } else if (error.status === 404) {
                            this.ga.trackEvent("QRCode invalide", "scan");
                        }
                    });
                }
            }
        }, (error: any) => {
            console.error(error);
        });
    }

    goToPage(page: string, data: any): any {        
        data = (page === 'connexion' && this.qrCodeScan !== '') ? { qrCode: this.qrCodeScan } : {};
        this.qrCodeScan = '';
        this.pageClicked.emit({ page, data });
    }
}



// WEBPACK FOOTER //
// ./src/pages/menu/menu.ts